<div v-if="breakdownForDisplay" class="tt-c-ratings-breakdown tt-u-spacing--md">
  <div class="tt-c-ratings-breakdown__heading tt-u-align-center" v-html="$msg('ratingsBreakdown.ratings', [total], total)"></div>
  <div class="tt-c-ratings-breakdown__table tt-u-spacing--xs">
    <template v-for="ratingData in breakdownForDisplay">
      <p class="tt-u-clip-hide" v-html="$msg('ratingsBreakdown.pctOfReviews', [ratingData.rating, ratingData.pctOfRatingsFormatted], ratingData.rating)"></p>
      <div v-bind="ratingData.isFilterable ? { role: 'button', tabindex: 0 } : {}"
           @keydown.enter.prevent="ratingSelected(ratingData.isFilterable ? ratingData : null)"
           @click.prevent="ratingSelected(ratingData.isFilterable ? ratingData : null)"
           class="tt-c-ratings-breakdown__bar-wrap"
           :aria-label="ratingData.isFilterable ? $msg('ratingsBreakdown.filterBy', [ratingData.rating]) : null">
        <span class="tt-c-ratings-breakdown__rating"><tt-icon name="star--full" size="sm" class="tt-c-ratings-breakdown__star tt-c-rating__icon"></tt-icon> <span class="tt-c-ratings-breakdown__rating-number" aria-hidden="true">{{ ratingData.rating }}</span></span>
        <span class="tt-c-ratings-breakdown__bar">
          <span class="tt-c-ratings-breakdown__bar-progress" :style="{width: ratingData.progressWidth}"></span>
        </span>
        <span class="tt-c-ratings-breakdown__percent" aria-hidden="true">{{ ratingData.pctOfRatingsFormatted }}</span>
    </div>
    </template>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/reviews-summary/ratings-breakdown.html